export class ErroApi extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

type Metodo = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

let aoExpirar: (() => void) | null = null;
export const definirAoExpirar = (fn: () => void) => {
  aoExpirar = fn;
};

export async function api<T>(
  caminho: string,
  opcoes: { metodo?: Metodo; corpo?: unknown } = {},
): Promise<T> {
  let r: Response;
  try {
    r = await fetch(caminho, {
      method: opcoes.metodo ?? 'GET',
      credentials: 'same-origin',
      headers: opcoes.corpo !== undefined ? { 'content-type': 'application/json' } : undefined,
      body: opcoes.corpo !== undefined ? JSON.stringify(opcoes.corpo) : undefined,
    });
  } catch {
    throw new ErroApi(0, 'Sem conexão com o servidor. Confira a internet e tente de novo.');
  }

  const dados = r.headers.get('content-type')?.includes('application/json') ? await r.json() : null;
  if (!r.ok) {
    if (r.status === 401 && caminho !== '/api/eu' && !caminho.endsWith('/auth/login'))
      aoExpirar?.();
    throw new ErroApi(r.status, dados?.erro ?? 'Algo deu errado. Tente de novo.');
  }
  return dados as T;
}

export async function enviarArquivo<T>(
  conversaId: string,
  arquivo: File | Blob,
  opcoes: { nome?: string; legenda?: string; respondeAId?: string } = {},
): Promise<T> {
  const form = new FormData();
  if (opcoes.legenda) form.append('legenda', opcoes.legenda);
  if (opcoes.respondeAId) form.append('respondeAId', opcoes.respondeAId);
  form.append(
    'arquivo',
    arquivo,
    opcoes.nome ?? (arquivo instanceof File ? arquivo.name : 'arquivo'),
  );
  let r: Response;
  try {
    r = await fetch(`/api/conversas/${conversaId}/midias`, {
      method: 'POST',
      body: form,
      credentials: 'same-origin',
    });
  } catch {
    throw new ErroApi(0, 'Sem conexão com o servidor. Confira a internet e tente de novo.');
  }
  const dados = r.headers.get('content-type')?.includes('application/json') ? await r.json() : null;
  if (!r.ok) {
    if (r.status === 401) aoExpirar?.();
    throw new ErroApi(r.status, dados?.erro ?? 'Não consegui enviar o arquivo. Tente de novo.');
  }
  return dados as T;
}

export const get = <T>(caminho: string) => api<T>(caminho);
export const post = <T>(caminho: string, corpo?: unknown) =>
  api<T>(caminho, { metodo: 'POST', corpo: corpo ?? {} });
export const patch = <T>(caminho: string, corpo: unknown) =>
  api<T>(caminho, { metodo: 'PATCH', corpo });
